import React from 'react';

const escapeRegExp = (s) => String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');

/**
 * Renders `text` with every case-insensitive match of `query` wrapped in <mark>.
 * Plain React nodes — never HTML injection, whatever the text contains.
 */
const Highlight = ({ text, query, minLength = 1 }) => {
  const source = text == null ? '' : String(text);
  const q = String(query || '').trim();
  if (q.length < minLength) return source;

  const parts = source.split(new RegExp(`(${escapeRegExp(q)})`, 'ig'));
  const needle = q.toLowerCase();
  return parts.map((part, index) => (
    part.toLowerCase() === needle
      ? <mark key={index} className="rounded bg-amber-200/80 px-0.5 text-inherit dark:bg-amber-500/30">{part}</mark>
      : <React.Fragment key={index}>{part}</React.Fragment>
  ));
};

export default Highlight;
